export default __webpack_public_path__ + "static/media/evening-icon.a3d500d5.svg";